import { render, staticRenderFns } from "./WoundHistoryModal.vue?vue&type=template&id=6f03af41&"
import script from "./WoundHistoryModal.vue?vue&type=script&lang=js&"
export * from "./WoundHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./WoundHistoryModal.vue?vue&type=style&index=0&id=6f03af41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports